import { Stack } from '@mui/material';

import { LargeSkeleton, SmallSkeleton, UserStack } from './ChatSkeletonStyle';

const ChatSkeleton = () => (
  <Stack>
    <UserStack>
      <SmallSkeleton />
    </UserStack>
    <Stack direction="row">
      <SmallSkeleton />
    </Stack>
    <LargeSkeleton />
    <UserStack>
      <SmallSkeleton />
    </UserStack>
    <LargeSkeleton />
    <Stack direction="row">
      <SmallSkeleton />
    </Stack>
    <LargeSkeleton />
    <UserStack>
      <SmallSkeleton />
    </UserStack>
    <Stack direction="row">
      <SmallSkeleton />
    </Stack>
    <LargeSkeleton />
  </Stack>
);

export default ChatSkeleton;
